import { Heading } from '@chakra-ui/react';
import { useQuery } from 'react-query';
import Section from '../../Component/Layout/Section';
import { getPage } from '../../service';
import { PageContentsStyle } from './style';

type Props = {
  slug: string;
};

function Page({ slug }: Props) {
  
  const { isLoading, error, data } = useQuery('getPage', () => getPage(slug));

  return (
    !isLoading && !error && data && (
    <>
    <Section pt={40} pb={40}>
      <Heading size="4xl" pb="10" >{data.title.rendered}</Heading>
      <PageContentsStyle dangerouslySetInnerHTML={ {__html: data.content.rendered} } />
    </Section>
    </>
    )
  );
}

Page.defaultProps = {
};

export default Page;
